import { PopoverProps } from 'react-tiny-popover';

export enum TooltipColors {
  BLACK = 'black',
  RED = 'red',
  WHITE = 'white',
  EGGPLANT = 'eggplant',
}

export interface TooltipProps extends Omit<PopoverProps, 'isOpen' | 'content' | 'children'> {
  className?: string;
  content: React.ReactNode;
  isOpen?: boolean;
  showArrow?: boolean;
  showShadow?: boolean;
  /** If true (default), append an info circle icon after `children` */
  showInfoCircle?: boolean;
  tooltipColor?: TooltipColors;
  tooltipMaxWidth?: string;
  isDisabled?: boolean;
}
